import { Progress } from 'antd';
import { ProgressProps } from 'antd/lib/progress';
import React from 'react';

export class ProgressBar extends React.PureComponent<ProgressProps> {
  render(): React.ReactNode {
    return <Progress {...this.props}/>;
  }
}